var _defs, _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path0, _ellipse2, _ellipse3, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSterilize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.222,
    height: 20.49,
    viewBox: "0 0 21.222 20.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sterilize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#758091;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39,50h1.464v1.464H39Z",
    transform: "translate(-25.462 -33.169)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39,40h1.464v1.464H39Z",
    transform: "translate(-25.462 -26.828)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cy: 0.5,
    ry: 0.5,
    transform: "translate(16 10)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51,52h1.1v.732H51Z",
    transform: "translate(-33.071 -34.438)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51,48h1.1v.732H51Z",
    transform: "translate(-33.071 -31.9)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51,44h1.1v.732H51Z",
    transform: "translate(-33.071 -29.364)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26,50h1.464v1.464H26Z",
    transform: "translate(-17.219 -33.169)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(12 10)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26,40h1.464v1.464H26Z",
    transform: "translate(-17.219 -26.828)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51,40h1.1v.732H51Z",
    transform: "translate(-33.071 -26.828)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26,15.122h2.591a2.556,2.556,0,0,1,4.065-1.683L34.887,11.2l.52.52-2.236,2.232a2.517,2.517,0,0,1,.483,1.167h2.591V10H26Z",
    transform: "translate(-17.219 -7.805)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.893,20A1.836,1.836,0,0,0,35.1,21.464h3.586A1.831,1.831,0,0,0,36.893,20Z",
    transform: "translate(-22.989 -14.146)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 0.5,
    cy: 1,
    rx: 0.5,
    ry: 1,
    transform: "translate(9 9)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cy: 0.5,
    ry: 0.5,
    transform: "translate(19 10)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.074,4H22.561A2.564,2.564,0,0,0,20,6.561v7.318h1.515a1.464,1.464,0,1,1,0,.732H20V24.49H34.636V6.561A2.564,2.564,0,0,0,32.074,4ZM24.391,22.66a.366.366,0,0,1-.366.366h-2.2a.366.366,0,0,1-.366-.366v-2.2a.366.366,0,0,1,.366-.366h2.2a.366.366,0,0,1,.366.366Zm0-3.659a.366.366,0,0,1-.366.366h-2.2A.366.366,0,0,1,21.464,19v-2.2a.366.366,0,0,1,.366-.366h2.2a.366.366,0,0,1,.366.366Zm.732-4.757a1.1,1.1,0,1,1,1.1,1.1A1.1,1.1,0,0,1,25.122,14.245Zm4.025,8.415a.366.366,0,0,1-.366.366h-2.2a.366.366,0,0,1-.366-.366v-2.2a.366.366,0,0,1,.366-.366h2.2a.366.366,0,0,1,.366.366Zm0-3.659a.366.366,0,0,1-.366.366h-2.2A.366.366,0,0,1,26.22,19v-2.2a.366.366,0,0,1,.366-.366h2.2a.366.366,0,0,1,.366.366Zm0-3.659a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,29.147,15.343Zm4.025,7.318a.366.366,0,0,1-.366.366H30.977a.366.366,0,0,1-.366-.366V16.806a.366.366,0,0,1,.366-.366h1.829a.366.366,0,0,1,.366.366Zm-1.1-7.318a1.1,1.1,0,1,1,1.1-1.1,1.1,1.1,0,0,1-1.1,1.1Zm1.1-3.659a.366.366,0,0,1-.366.366H21.829a.366.366,0,0,1-.366-.366V5.829a.366.366,0,0,1,.366-.366H32.806a.366.366,0,0,1,.366.366Z",
    transform: "translate(-13.414 -4)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.025,27.927v1.145a1.7,1.7,0,0,1,1.1,1.782,2.139,2.139,0,0,1-.19.882.243.243,0,0,1-.033.07,2.185,2.185,0,0,1-3.944,0,.243.243,0,0,1-.033-.07,2.139,2.139,0,0,1-.19-.882,1.7,1.7,0,0,1,1.1-1.782V27.927H2V27.2H3.829V25.732H3.1V25H6.757v.732H6.025V27.2H7.854v.732Z",
    transform: "translate(-2 -17.316)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSterilize);
export default __webpack_public_path__ + "static/media/sterilize.94f1641f424e192114cd7bd3fd4632f4.svg";
export { ForwardRef as ReactComponent };